import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getConfigByCode } from 'y4/Falcon';
import { useLocation, useParams } from 'react-router-dom';
import AuthCardLayout from 'layouts/AuthCardLayout';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

const Shortener = () => {
  const { t } = useTranslation('shortener');
  const location = useLocation();
  let params = useParams();

  const [link, setLink] = useState({
    title: 'Loading....',
    description: 'Url is still loading, please wait'
  });

  useEffect(() => {
    getConfigByCode(params.id, 'Shortener').then(cs => {
      if (_.isEmpty(cs)) {
        setLink({
          title: '404',
          description: 'The url no longer exists'
        });
      } else {
        let to = cs[0].url;
        if (to) {
          if (location.search) {
            const flag = to.includes('?') ? '&' : '?';
            to = to + flag + location.search.slice(1);
          }
          if (_.startsWith(to, 'http')) {
            window.location.replace(to);
          } else {
            //navigate(to, { replace: true });
            //使用 navigate 不会执行 Falcon.init，也不会显示 cron 对应的网页标题
            window.location.replace(to);
          }
        } else {
          setLink({
            title: '404',
            description: 'The url no longer exists'
          });
        }
      }
    });
  }, []);

  return (
    <AuthCardLayout
      leftSideContent={
        <p className="text-white">
          <Link className="text-white text-decoration-underline" to="/">
            {t('Take me home')}
          </Link>
        </p>
      }
    >
      <h5 className="mb-0 mt-1">{t(link.title)}</h5>
      <div className="pt-3">{t(link.description)}</div>
    </AuthCardLayout>
  );
};

export default Shortener;
